import fr from "./fr";
import en from "./en";

export default {
    fr,
    en
};
